export default __webpack_public_path__ + "static/media/Planet.fa6f22b7.png";